import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { SidePanelContext, SidePanelMode, SidePanelState } from './scheduling.types';

const initialState: SidePanelState = {
  context: {},
  isOpen: false,
  mode: null
};

const schedulingSidePanelSlice = createSlice({
  initialState,
  name: 'schedulingSidePanel',
  reducers: {
    closeSidePanel: (state) => {
      state.isOpen = false;
      state.mode = null;
      state.context = {};
    },
    openSidePanel: (
      state,
      action: PayloadAction<{ context?: SidePanelContext; mode: SidePanelMode }>
    ) => {
      state.isOpen = true;
      state.mode = action.payload.mode;
      state.context = action.payload.context ?? {};
    }
  }
});

export const { closeSidePanel, openSidePanel } = schedulingSidePanelSlice.actions;

export const selectSidePanel = (state: RootState) => state.schedulingSidePanel;

export default schedulingSidePanelSlice.reducer;
